/**
 * @fileoverview Rutas del módulo de Soporte en el Dashboard (UC-REG-098).
 *
 *               Se importa y spreadea en `src/router/index.js` junto con
 *               las demás rutas del Main layout.
 *
 *               Rutas:
 *                 /support/kb                — KBList
 *                 /support/kb/new            — KBEditor (crear)
 *                 /support/kb/:id            — KBEditor (editar)
 *                 /support/kb/:id/diff       — KBDiffView
 *                 /support/kb/sources        — KBSourcesExplorer
 *                 /support/inbox             — SupportInbox (operador)
 *                 /support/conversation/:id  — SupportConversationView
 *                 /support/metrics           — SupportMetrics
 *                 /support/settings          — SupportSettings (admin)
 *
 *               Gates: cada vista se asume gateada por v-has-permission
 *               (cargada en `SidebarNav`). Las rutas no tienen meta de
 *               permiso porque el router del proyecto no las consume —
 *               el sidebar es quien oculta y el endpoint es quien rechaza.
 */

const supportRoutes = [
  {
    path: "/support/kb",
    name: "support-kb-list",
    component: () => import("../views/support/KBList.vue"),
  },
  {
    path: "/support/kb/sources",
    name: "support-kb-sources",
    component: () => import("../views/support/KBSourcesExplorer.vue"),
  },
  {
    path: "/support/kb/new",
    name: "support-kb-new",
    component: () => import("../views/support/KBEditor.vue"),
  },
  {
    path: "/support/kb/:id",
    name: "support-kb-edit",
    component: () => import("../views/support/KBEditor.vue"),
  },
  {
    path: "/support/kb/:id/diff",
    name: "support-kb-diff",
    component: () => import("../views/support/KBDiffView.vue"),
  },
  {
    path: "/support/inbox",
    name: "support-inbox",
    component: () => import("../views/support/SupportInbox.vue"),
  },
  {
    path: "/support/conversation/:id",
    name: "support-conversation",
    component: () => import("../views/support/SupportConversationView.vue"),
  },
  {
    path: "/support/metrics",
    name: "support-metrics",
    component: () => import("../views/support/SupportMetrics.vue"),
  },
  {
    path: "/support/settings",
    name: "support-settings",
    component: () => import("../views/support/SupportSettings.vue"),
  },
];

export default supportRoutes;
